import React from 'react'
import { GridItem } from '@which/seatbelt'

import type { SubVerticalCrTopicPageQuery } from '../../../../generated/frontend'
import { Breadcrumb, Callout, LocalFooter, TaxonomyConversionBanner } from '../../../../shared'
import { CRCategories } from '../../components/CRCategories'
import { SubVerticalHeader } from '../../components/SubVerticalHeader'
import { SuperCategoryJumpLinks } from '../../components/SuperCategoryJumpLinks'

export const getSubVerticalCRTopicComponents = (
  data: SubVerticalCrTopicPageQuery['subVerticalPage']
) => {
  const {
    header,
    callout,
    crCategories: {
      jumpLinks: { links: crJumpLinks },
      sections: crSections,
    },
    breadcrumb,
    taxonomyConversionBanner,
    consumerRightsFooter,
    consumerRightsNavigation,
  } = data

  return {
    SubVerticalHeader: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <SubVerticalHeader {...header} />
      </GridItem>
    ),
    SubVerticalJumpLinks: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <SuperCategoryJumpLinks links={crJumpLinks} />
      </GridItem>
    ),
    Breadcrumb: () => <Breadcrumb {...breadcrumb} localNavProps={consumerRightsNavigation} />,
    Callout: () => (
      <GridItem span={{ large: 10 }} columnStart={{ large: 2 }}>
        <Callout {...callout} />
      </GridItem>
    ),
    CRCategories: () => (
      <GridItem span={{ medium: 8, large: 8 }} columnStart={{ medium: 3, large: 3 }}>
        <CRCategories categories={crSections} />
      </GridItem>
    ),
    TaxonomyConversionBanner: () => (
      <GridItem span={{ small: 'full-bleed', medium: 'full-bleed', large: 'full-bleed' }}>
        <TaxonomyConversionBanner {...taxonomyConversionBanner} />
      </GridItem>
    ),
    ConsumerRightsFooter: () => (
      <GridItem>
        <LocalFooter data={consumerRightsFooter} />
      </GridItem>
    ),
  }
}
